<template> 
  <b-form @submit.stop.prevent="submit">
    <b-form-group label="Title">
      <b-form-input v-model="form.title" required></b-form-input>
    </b-form-group>

    <div class="row">
      <div class="col">
        <b-form-group label="Author">
          <b-form-select v-model="form.author" :options="authors" class="form-control"></b-form-select>
        </b-form-group>
      </div>

      <div class="col">
        <b-form-group label="Date">
          <DatePicker v-model="form.date" :disabled-dates="datepicker.disabledDates" input-class="form-control"></datepicker>
        </b-form-group>
      </div>
    </div>
  
    <div class="full" ref="full">
      <div class="editor">
        <QuillEditor v-model="form.body"></QuillEditor>
      </div>

      <div class="d-grid gap-2 mt-4">
        <div @click="toggle" v-if="fullscreen" class="btn btn-secondary">Toggle fullscreen</div>
      </div>
    </div>

    <div class="d-flex flex-row-reverse">
      <b-button type="submit" variant="primary">Save</b-button>
    </div>
  </b-form>
</template>

<script>
  import gql from 'graphql-tag'

  import screenfull from 'screenfull';

  import DatePicker from '@sum.cumo/vue-datepicker'
  import QuillEditor from '../../components/QuillEditor';

  const CREATE_DOCUMENT = gql`
    mutation CreateDocument($input: documents_insert_input!) {
      document: insert_documents_one(object: $input) {
        id
        title
        body
        author
        date
        created_at
        updated_at
      }
    }
  `;

  const UPDATE_DOCUMENT = gql`
    mutation UpdateDocument($id: uuid!, $input: documents_set_input!) {
      document: update_documents_by_pk(
        pk_columns: { id: $id },
        _set: $input
      ) {
        id
        title
        body
        author
        date
        created_at
        updated_at
      }
    }
  `;

  export default {
    props: ['id', 'document'],

    components: {
      DatePicker, QuillEditor
    },

    data() {
      return {
        form: this.initForm(),

        authors: [
          'Bro. Roger Smith',
          'Bro. Greg Patterson',
          'Bro. Mike Geransky'
        ],

        datepicker: {
          disabledDates: {
            days: [1, 2, 4, 5]
          }
        },

        fullscreen: screenfull.isEnabled
      }
    },

    watch: {
      form: {
        handler() {
          this.$emit('changed');
        },

        deep: true
      }
    },

    methods: {
      initForm() {
        function dateToday() {
          const date = (new Date());

          return [date.getFullYear(), (date.getMonth() + 1).toString().padStart(2, '0'), date.getDate().toString().padStart(2, '0')].join('-')
        }

        return {
          title: this.document && this.document.title,
          body: this.document && this.document.body || '',
          author: this.document && this.document.author || 'Bro. Roger Smith',
          date: this.document && this.document.date || dateToday(),
        }
      },

      toggle() {
        screenfull.toggle(this.$refs.full);
      },

      submit() {
        if (this.document) {
          this.update();
        } else {
          this.create();
        }
      },

      create() {
        this.$apollo.mutate({
          mutation: CREATE_DOCUMENT,

          variables: {
            input: this.form
          },

          update: (cache, { data }) => {
            this.form = this.initForm();
            this.$emit('saved', data.document, { cache });
          }
        })
      },

      update() {
        const id = this.$props.document.id;
        
        this.$apollo.mutate({
          mutation: UPDATE_DOCUMENT,

          variables: {
            id,
            input: this.form
          }
        }).then(({ data }) => {
          this.$emit('saved', data.document, {})
        })
      }
    }
  }
</script>

<style>
  @import '~@sum.cumo/vue-datepicker/dist/Datepicker.css';

  .editor {
    height: 250px;
  }

  .full:fullscreen .editor {
    height: calc(100vh - 4rem);
  }

  .full {
    padding: 1rem 0;
  }

  .full:fullscreen {
    background: #fff;
    padding: 1rem;
  }
</style>